/* 
This file is copied from the Amplitude library experiment-node-server
https://github.com/amplitude/experiment-node-server/blob/main/packages/node/src/cookie.ts
Since we are using this file in the Edge runtime, we cannot import the AmplitudeCookie class
*/
import type { Variant } from '@amplitude/experiment-js-client'

import { log } from '@src/utils/log.util'

export function cookieName(amplitudeApiKey: string, newFormat = false): string {
  if (newFormat) {
    if (amplitudeApiKey?.length < 10) {
      throw Error('Invalid Amplitude API Key')
    } else {
      return 'AMP_' + amplitudeApiKey.substring(0, 10)
    }
  }
  if (amplitudeApiKey?.length < 6) {
    throw Error('Invalid Amplitude API Key')
  }
  return 'amp_' + amplitudeApiKey.substring(0, 6)
}

export function parse(amplitudeCookie: string, newFormat = false): any {
  if (newFormat) {
    const decoding = Buffer.from(amplitudeCookie, 'base64').toString('utf-8')
    try {
      const userSession = JSON.parse(decodeURIComponent(decoding))
      return {
        device_id: userSession.deviceId,
        user_id: userSession.userId,
      }
    } catch (error: any) {
      log.error(`[Amplitude] Error parsing amplitude cookie - ${error.message}`, error)
      return {}
    }
  }
  const values = amplitudeCookie.split('.')
  let user_id
  if (values[1]) {
    try {
      user_id = Buffer.from(values[1], 'base64').toString('utf-8')
    } catch (error: any) {
      log.error(`[Amplitude] Error parsing amplitude cookie - ${error.message}`, error)
      user_id = undefined
    }
  }
  return {
    device_id: values[0],
    user_id,
  }
}

export function generate(deviceId: string, newFormat = false): string {
  if (!newFormat) {
    return deviceId + '..........'
  }

  const userSessionHash = {
    deviceId,
  }

  const json_data = JSON.stringify(userSessionHash)
  const encoded_json = encodeURIComponent(json_data)
  const base64Encoded = Buffer.from(encoded_json).toString('base64')
  return base64Encoded
}

export function serializeExperiments(experiments: Record<string, Variant> = {}) {
  let allVariantsWithValues = ''
  Object.keys(experiments).forEach((key) => {
    allVariantsWithValues += `${key}: ${experiments[key].value},`
  })
  return allVariantsWithValues
}
